import { toast as sonner } from "sonner";
import { triggerHaptic } from "@/lib/haptics";

const withHaptic = (fn, pattern) => (message, opts) => { triggerHaptic(pattern); return fn(message, opts); };

export const toast = Object.assign((message, opts) => sonner(message, opts), {
  ...sonner,
  success: withHaptic(sonner.success, "success"),
  error: withHaptic(sonner.error, "error"),
  warning: withHaptic(sonner.warning, "warning"),
  info: withHaptic(sonner.info, "tap"),
});
